// extracted by mini-css-extract-plugin
module.exports = {"imageSelector":"imageSelector_imageSelector__8Dyr5","fileInput":"imageSelector_fileInput__3jtrQ","selectedImg":"imageSelector_selectedImg__WYaOy"};